<template>
  <div>
    <div class="row">
      <div v-for="dFilter in dateFilter" :key="dFilter.key" class="col-6">
        <label>{{dFilter.title}} <span v-show="params[dFilter.key]" @click="params[dFilter.key]=null" class="link">сбросить</span></label>
        <datetime  v-model="params[dFilter.key]"  @input="params['page'] = 1"  class="from-control"  type="date" format="dd/MM/yyyy"></datetime> 
      </div>
      <div class="col-6">
        <template v-if="params.from && params.to">
          <blob-download 
            :params="params" 
            :url="`/dealers/${this.id}/export-orders`" 
            :name="this.item.llc_name || this.item.id || 'Бизнесы-заказы'" 
            class="m-y-2">
            Выгрузить
          </blob-download>
        </template>
      </div>
    </div>
    <list
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="false"
      :itemLink="itemLink"
      :setLink="setLink"
      :fields="fields"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";
export default {
  name: "products",
props:{
  id: {
    default : null
  }
},
async created() {
  this.itemLink =  `dealers/${this.id}/orders`;
  this.setLink = `dealers/${this.id}/orders`;

  this.urlDownload = `/users/${this.id}/tp-prods`
  this.item = await this.cardContent('dealers', this.id);
},
methods: {
    changeFunction(val) {},
    change(val) {},
    cardUpdate: cardUpdate,
    cardContent: cardContent,
  },
  data() {
    return {
      val: [],
      params: {},
      modalCreate: "status",
      dateFilter:[
        {
          key:'from',
          title:'Начало даты',
        },
        {
          key:'to',
          title:'Конец даты',
        },
      ],
      fields: [
        
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_order",
      itemLink: "orders",
      setLink: "orders",
   columns: [
         {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
        {
          key: "status",
          object: "title",
          title: "Статус",
          disableLink:true
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
  
  
        {
          key: "is_paid",
          title: "Оплачен",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
